import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Stack, Typography, InputAdornment, Grid } from '@mui/material';
import { InputNumber } from 'app/components/elements/InputNumber';

import { InputText } from 'app/components/elements/InputText';
import { FormPostSeizure } from './modules/FormPostSeizure/FormPostSeizure';
import CustomDatePicker from '../../../../../components/elements/InputDate';
import dayjs from 'dayjs';
import { IconMoney } from '../../../../../../assets/icon';

const NextPaymentSection: React.FC = () => {
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext<FormPostSeizure>();

  return (
    <Stack gap={2}>
      <Typography style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>
        Next Payment Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Controller
            name={'nextPaymentDetail.nextPaymentDate'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <CustomDatePicker
                inputError={errors?.nextPaymentDetail?.nextPaymentDate?.message}
                title={'Next Payment Date'}
                value={value ? dayjs(value) : null}
                onChange={onChange}
                datePickerProps={{}}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Controller
            name={'nextPaymentDetail.installmentAmount'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <InputNumber
                title="Installment Amount"
                placeholder="Installment Amount"
                endAdornment={
                  <InputAdornment position="end">
                    <IconMoney />
                  </InputAdornment>
                }
                value={value}
                onChange={onChange}
                inputProps={{}}
                inputError={errors?.nextPaymentDetail?.installmentAmount?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputText
            inputError={errors?.nextPaymentDetail?.frequency?.message as string}
            placeholder="Enter frequency"
            title="Frequency"
            inputProps={{
              ...register('nextPaymentDetail.frequency')
            }}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default NextPaymentSection;
